import { CountryInterface, CountryState } from '../../models/state';
import { actionTypes } from '../actions/country';

const initialState: CountryState = {
  country: {} as CountryInterface,
  countries: [],
  countryCount: 0,
  simpleFilters: { regions: [], countries: [] },
};
const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_COUNTRIES_SUCCESS: {
      return {
        ...state,
        countries: action.payload.rows,
        countryCount: action.payload.count,
      };
    }
    case actionTypes.GET_ALL_REGIONS_SUCCESS: {
      return {
        ...state,
        simpleFilters: {
          ...state.simpleFilters,
          regions: action.payload,
        },
      };
    }
    case actionTypes.GET_ALL_COUNTRIES_SUCCESS: {
      return {
        ...state,
        simpleFilters: {
          ...state.simpleFilters,
          countries: action.payload,
        },
      };
    }

    default: {
      return state;
    }
  }
};

export default countryReducer;
